import { Stack } from '@mui/material'
import { useMarketNavigate } from 'hooks/useMarketNavigate'
import { FC, memo } from 'react'
import { StringFormatter } from 'utils/StringFormatter'
import { useAppDispatch } from '../../store'
import { useCurrencyByName, useTicker } from '../../store/market/hooks'
import { FlexItem } from '../../styles'
import { toFixed } from '../../utils/number'
import { CombinedSymbol, isSpotSymbol } from '../../utils/symbols'
import {
  MarketIcon,
  MarketItemWrap,
  MarketName,
  MarketPrice,
  MarketRange,
} from './styles'
import { updateModal } from '../../store/app/actions/modalActions'

export const MarketItem: FC<{
  item: CombinedSymbol
}> = memo(({ item }) => {
  const { name = '', baseCurrency = '', quoteCurrency = '' } = item
  const { close = 0, percent = 0 } = useTicker(name) ?? {}
  const { navigateToSpot, navigateToPerp } = useMarketNavigate()

  const dispatch = useAppDispatch()
  const currencyInfo = useCurrencyByName(baseCurrency)

  const isSpot = isSpotSymbol(item)
  return (
    <MarketItemWrap
      onClick={() => {
        dispatch(
          updateModal({
            modal: 'marketDrawer',
            open: false,
          }),
        )
        if (isSpot) {
          navigateToSpot(baseCurrency, quoteCurrency)
        } else {
          navigateToPerp(baseCurrency, quoteCurrency)
        }
      }}
    >
      <MarketIcon src={currencyInfo?.tokenIconUrl} />
      <FlexItem>
        <MarketName>
          {baseCurrency}
          {isSpot ? <span>/{quoteCurrency}</span> : <span>-Perp</span>}
        </MarketName>
      </FlexItem>
      <Stack sx={{ textAlign: 'right' }}>
        <MarketPrice>{close}</MarketPrice>

        <MarketRange
          style={{ color: Number(percent) >= 0 ? '#419e6a' : '#D83232' }}
        >
          {StringFormatter.numberSign(toFixed(percent, 2))}%
        </MarketRange>
      </Stack>
    </MarketItemWrap>
  )
})
